import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { captureException } from '@sentry/react';
import { Typography } from '@mui/material';

export function RootErrorBoundary() {
  const error = useRouteError() as Error;

  useEffect(() => {
    captureException(error, { level: 'fatal' });
  }, [error]);

  return <Typography variant="h1">Error</Typography>;
}
